/**
 * Every route path, in one place.
 *
 * Centralised so a rename is one edit rather than a search, and so a typo in a navigation
 * target is a type error rather than a dead link discovered by a user.
 */

export const PATHS = {
  root: '/',
  overview: '/overview',
  allocations: '/allocations',
  allocationEditor: '/allocations/:workerId/edit',
  approvals: '/approvals',
  approvalDetail: '/approvals/:approvalId',
  myUsage: '/my-usage',
  auditLog: '/audit',
  adk: '/adk',
  agenticDelivery: '/adk/agentic-delivery',
  accessDenied: '/access-denied',
  signedOut: '/signed-out',
  // Outside the authenticated shell entirely -- see router.tsx's own comment on why
  // this is a sibling route object, not a child route under PATHS.root. Reachable only
  // from the signed, single-use link an `approval_requested` email carries; there is no
  // in-app navigation link to it.
  approvalAction: '/actions/:friendlyId',
} as const

export function allocationEditorPath(workerId: string): string {
  return `/allocations/${encodeURIComponent(workerId)}/edit`
}

export function approvalDetailPath(approvalId: string): string {
  return `/approvals/${encodeURIComponent(approvalId)}`
}

export function approvalActionPath(friendlyId: string): string {
  return `/actions/${encodeURIComponent(friendlyId)}`
}
